const hostname = window.location.hostname;
let API_BASE_URL;

if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '10.0.0.245') {
  // Development environment
  API_BASE_URL = 'http://localhost:3001'; //change to IP of the local machine if want to test on mobile!
} else {
  // becuase on the server we use a reverseproxy on apache to redirect any /api calls to the 3001 port in localhost on the server for the backend service. 
  // but on the dev machine we dont have a reverse proxy setup
  API_BASE_URL = '/api'; 
}

export default API_BASE_URL;

export const getEvents = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/events`);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching events:', error);
    throw error;
  }
};
